export default __webpack_public_path__ + "static/media/NoFeeGuarantee.cea079bd.png";